import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Navbar from './components/navbar/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Connect from './pages/Connect';
import Collaborate from './pages/Collaborate';

function App() {
    return (
        <Router>
            <div>
                <Navbar />
                <Routes>
                    <Route path="/about" element={<About />} />
                    <Route path="/connect" element={<Connect />} />
                    <Route path="/nomadity-insider" element={<Collaborate type="Insider" />} />
                    <Route path="/nomadity-partner" element={<Collaborate type="Partner" />} />
                    <Route path="/" element={<Home />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
